import Cookies from 'js-cookie';

/**
 * Window event dispatched whenever the local session becomes invalid:
 * either the user pressed "Cerrar sesión" on the forbidden screen, or
 * the backend answered 401 mid-session. The guard listens for it and
 * re-resolves `AuthStatus`, dropping to the "no-jwt" screen without a
 * full page reload.
 */
export const AUTH_INVALIDATED_EVENT = 'auth:invalidated';

/**
 * Drops the local session: removes the `jwt` cookie and notifies the
 * guard so the UI transitions to the "Sesión requerida" screen.
 * Idempotent — safe to call multiple times.
 */
export function invalidateSession(): void {
  Cookies.remove('jwt');
  window.dispatchEvent(new Event(AUTH_INVALIDATED_EVENT));
}

/**
 * Registers `handler` to be called whenever `invalidateSession()`
 * fires. Returns a cleanup function suitable for `useEffect`.
 */
export function subscribeToAuthInvalidation(handler: () => void): () => void {
  window.addEventListener(AUTH_INVALIDATED_EVENT, handler);
  return () => window.removeEventListener(AUTH_INVALIDATED_EVENT, handler);
}
